import React, { useEffect, useMemo, useRef, useState } from "react";
import { Container, Form, Row, Col, Button, Card, InputGroup } from "react-bootstrap";
import Swal from "sweetalert2";
import { FaChevronDown, FaCheck, FaLock, FaPhone, FaWhatsapp, FaEnvelope } from "react-icons/fa";
import EmployerNavbar from "../../Pages/Navbar/EmployerNavbar";
import AgencyNavbar from "../../Pages/Navbar/AgencyNavbar";
import BaseUrl from "../../ApiServices/BaseUrl";
import {
  HEALTHCARE_POSITIONS,
  HOSPITALITY_POSITIONS,
  SOFTWARE_IT_POSITIONS,
  CONSTRUCTION_POSITIONS,
  RETAIL_SALES_POSITIONS,
  CLEANING_MAINTENANCE_POSITIONS,
  COMPANY_WORKER_DUAL_CATEGORY_POSITIONS,
} from "../../../Constants/dropdownOptions";
import "./SendAlert.css";
import { useLocation } from "react-router-dom";

const comprehensiveJobPositions = [
  "Home Driver",
  "Home Cook",
  "Home Care Nurse",
  "Cleaner",
  "Home Caregiver",
  "Nanny",
  "Baby Sitter",
  "Elderly Care",
  "Company Driver",
  "Motorbike Driver",
  "Domestic Helper",
  "Maid",
  "Beautician",
  "Driver",
  "Driver (Company / House)",
  "Lady Driver",
  "Personal Driver",
  "Bus Driver",
  "Taxi Driver",
  "Cook",
  "Cook (Company / House)",
  "Nurse",
  "Houseboy",
  "Tailor",
  "Teacher",
  "Trainer",
  "Gardener",
  "Caregiver",
  "Hospital Nurse",
  "Physiotherapy",
  "Hospital Doctor",
  "Resident Doctor",
  "Heavy Driver",
  "Bike Driver",
  "JCB Operator",
  "Bulldozer Operator",
  "Excavator Operator",
  "Loader Operator",
  "Skid Steer Loader Operator",
  "Grader Operator",
  "Trench Excavator / Trencher Operator",
  "Backhoe Operator",
  "Dragline Operator",
  "Scraper Operator",
  "Crane Operator",
  "Telehandler Operator",
  "Reach Stacker Operator",
  "Boom Lift / Cherry Picker Operator",
  "Container Handler Operator",
  "Road Roller Operator",
  "Asphalt Paver Operator",
  "Bitumen Sprayer Operator",
  "Concrete Paver Operator",
  "Soil Stabilizer Operator",
  "Drilling Machine / Drill Rig Operator",
  "Rock Breaker / Hydraulic Hammer Operator",
  "Loader-Dumper Operator",
  "Dump Truck Operator",
  "Stone Crusher Operator",
  "Grizzly Feeder / Conveyor Operator",
  "Tractor Operator",
  "Harvester / Combine Operator",
  "Dozer / Land Leveling Operator",
  "Tower Crane Operator",
  "Mobile Crane Operator",
  "Crawler Crane Operator",
  "Piling Machine Operator",
  "Concrete Mixer Truck Operator",
  "Concrete Pump Operator",
  "Compactor Operator",
  "Pipe Layer Operator",
  "Forklift / Warehouse Equipment Operator",
  "Boom Truck / Loader Crane Operator",
  "Road Sweeper Operator",
  "Water Tanker / Firefighting Vehicle Operator",
  "Excavator Mounted Drill Operator",
  "Heavy Truck / Tip Truck Operator",
  "Loader Excavator Operator",
  "Teleporter Crane Operator",
  "Material Handler / Port Crane Operator",
  "Hydraulic Excavator Operator",
  "Multi-Functional Heavy M",
  "Workers",
  "Skilled Workers",
  "Construction Workers",
  "Skilled Construction Workers",
  "Mason",
  "Carpenter",
  "Steel Fixer",
  "Painter",
  "AC Technician",
  "HVAC Technician",
  "Chiller Technician",
  "Lathe & Milling Machine",
  "Lathe Machine Operator",
  "Milling Machine Operator",
  "Heavy Equipment Operator",
  "Scaffolder",
  "Healthcare Assistants",
  "Doctors",
  "Lab Technicians",
  "Physiotherapy",
  "Physiotherapists",
  "Elderly Care Workers",
  "Hospitality Workers",
  "Hotel Staff",
  "Waiters",
  "Waitresses",
  "Chefs",
  "Kitchen Helpers",
  "Baristas",
  "Factory Workers",
  "Production Workers",
  "Warehouse Workers",
  "Packing Staff",
  "Machine Operators",
  "Assembly Line Workers",
  "Forklift Operators",
  "Delivery Drivers",
  "Truck Drivers",
  "Logistics Staff",
  "Farm Workers",
  "Fruit Pickers",
  "Dairy Workers",
  "Poultry Workers",
  "Greenhouse Workers",
  "Caretakers",
  "Private Drivers",
  "CNC Operator",
  "CNC Programmer",
  "Machine Operator",
  "Assembly Line Worker",
  "Production Worker",
  "6G Certified Pipe Welder",
  "6G TIG + SMAW Pipe Welder",
  "6G / 6GR Pipe Welder",
  "High Pressure 6G Pipe Welder",
  "ASME 6G Pipe Welder",
  "6G Oil & Gas Pipe Welder",
  "MIG Welder",
  "TIG Welder",
  "Industrial Welder",
  "Fabricator",
  "Pipe Fitter",
  "Steel Structure Welder",
  "Shipyard Welder",
  "FCAW Welder (Shipyard)",
  "MIG/MAG Welder (Shipyard)",
  "TIG Welder (Shipyard)",
  "6G Pipe Welder (Shipyard)",
  "Electrician",
  "Plumber",
  "Industrial Electrician",
  "Maintenance Electrician",
  "Panel Electrician",
  "Maintenance Technician",
  "Electrical Technician",
  "PLC Technician",
  "Automation Technician",
  "Elevator Technician",
  "Elevator Installation Technician",
  "Elevator Maintenance Technician",
  "Elevator Repair Technician",
  "Escalator Technician",
  "Heavy Truck Mechanic",
  "Diesel Mechanic",
  "Auto Mechanic",
  "Bus Mechanic",
  "Vehicle Technician",
  "Construction Worker",
  "Warehouse Worker",
  "Forklift Operator",
  "Picker & Packer",
  "Delivery Van Driver",
  "Light Driver",
  "Logistics Assistant",
  "Heavy Truck Driver (CE)",
  "Trailer Driver",
  "Chef",
  "Kitchen Assistant",
  "Hotel Housekeeping",
  "Medical Technician",
  "Instrument Technician",
  "Mechanical Maintenance Technician",
  "Heavy Equipment Mechanic",
  "6G Welder",
  "Structural Welder",
  "Heavy Trailer Driver",
  "Fuel Tanker Driver",
  "Ready-Mix Driver",
  "Registered Nurse",
  "Physiotherapy",
  "Professional Chef",
  "Any Nurse",
  "Clinic / Shop Nurse",
  "School Nurse",
  "Company / Industrial Nurse",
  "Special Care Nurse",
  "Emergency / Ambulance Nurse",
  "Lab / Assistant Nurse",
  "Hotel / Resort Nurse",
  "General Physician",
  "Specialist Doctor",
  "Consultant Doctor",
  "Surgeon",
  "Pediatrician",
  "Gynecologist",
  "Orthopedic Doctor",
  "Cardiologist",
  "Neurologist",
  "Dermatologist",
  "ENT Specialist",
  "Ophthalmologist (Eye Doctor)",
  "Anesthesiologist",
  "Radiologist",
  "Psychiatrist",
  "Emergency Doctor",
  "ICU Doctor",
  "Family Medicine Doctor",
  "Dental Doctor",
  "Medical Officer",
  "Home Nurse",
  "House Nurse",
  "Elderly Care Nurse",
  "Salesman",
  "Sales Executive",
  "Senior Sales Executive",
  "Outdoor Salesman",
  "Indoor Salesman",
  "Business Development Executive",
  "Marketing Executive",
  "Digital Marketing Executive",
  "Tele-Sales Executive",
  "Account Manager (Sales)",
  "Receptionist",
  "Front Desk Executive",
  "Office Assistant",
  "Office Boy",
  "Office Helper",
  "Admin Assistant",
  "Customer Support Executive",
  "Call Center Agent",
  "Admin Executive",
  "Office Administrator",
  "Operations Executive",
  "Document Controller",
  "Data Entry Operator",
  "HR Assistant",
  "HR Executive",
  "Accountant",
  "Assistant Accountant",
  "Accounts Executive",
  "Cashier",
  "Billing Executive",
  "Payroll Executive",
  "Back Office Executive",
  "Office Coordinator",
  "Project Coordinator",
  "Logistics Coordinator",
  "Sales Coordinator",
  "Office Manager",
  "Operations Manager",
  "Admin Manager",
  "Sales Manager"
];

const sharedDropdownJobPositions = [
  ...HOSPITALITY_POSITIONS,
  ...SOFTWARE_IT_POSITIONS,
  ...CONSTRUCTION_POSITIONS,
  ...RETAIL_SALES_POSITIONS,
  ...CLEANING_MAINTENANCE_POSITIONS,
  ...HEALTHCARE_POSITIONS,
  ...COMPANY_WORKER_DUAL_CATEGORY_POSITIONS,
];

const normalizeOptionList = (options) =>
  Array.from(
    new Set(
      (Array.isArray(options) ? options : [])
        .map((option) => String(option ?? "").trim())
        .filter(Boolean)
    )
  );

const countries = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
];

const currencyOptions = [
  "QAR (Qatari Riyal)",
  "SAR (Saudi Riyal)",
  "AED (UAE Dirham)",
  "BHD (Bahraini Dinar)",
  "OMR (Omani Rial)",
  "KWD (Kuwaiti Dinar)",
  "EUR (Euro)",
  "GBP (British Pound Sterling)",
  "CHF (Swiss Franc)",
  "NOK (Norwegian Krone)",
  "SEK (Swedish Krona)",
  "DKK (Danish Krone)",
  "PLN (Polish Zloty)",
  "CZK (Czech Koruna)",
  "HUF (Hungarian Forint)",
  "RON (Romanian Leu)",
  "BGN (Bulgarian Lev)",
  "RSD (Serbian Dinar)",
  "TRY (Turkish Lira)",
  "USD (US Dollar)",
  "INR (Indian Rupee)",
  "SGD (Singapore Dollar)",
  "MYR (Malaysian Ringgit)",
  "HKD (Hong Kong Dollar)",
  "JPY (Japanese Yen)",
  "KRW (South Korean Won)",
  "ILS (Israeli Shekel)",
  "MUR (Mauritian Rupee)",
  "SCR (Seychellois Rupee)",
  "BND (Brunei Dollar)"
];

const SendAlert = ({ mode = "employer" }) => {
  const location = useLocation();
  const isAgencyMode = mode === "agency";
  const [jobPosition, setJobPosition] = useState("");
  const [jobPositionSearch, setJobPositionSearch] = useState("");
  const [showJobPositionDropdown, setShowJobPositionDropdown] = useState(false);
  
  const [jobLocation, setJobLocation] = useState("");
  const [jobLocationSearch, setJobLocationSearch] = useState("");
  const [showJobLocationDropdown, setShowJobLocationDropdown] = useState(false);

  const [salaryCurrency, setSalaryCurrency] = useState("AED (UAE Dirham)");
  const [salaryCurrencySearch, setSalaryCurrencySearch] = useState("");
  const [showSalaryCurrencyDropdown, setShowSalaryCurrencyDropdown] = useState(false);

  const [salaryAmount, setSalaryAmount] = useState("");
  const [message, setMessage] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [contactWhatsApp, setContactWhatsApp] = useState("");
  const [showContactDetails, setShowContactDetails] = useState(true);
  const [reachLimit, setReachLimit] = useState(10);
  const [templateIndex, setTemplateIndex] = useState(0);
  const [jobPositionOptions, setJobPositionOptions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [senderPlanType, setSenderPlanType] = useState("free");

  const positionDropdownRef = useRef(null);
  const locationDropdownRef = useRef(null);
  const currencyDropdownRef = useRef(null);

  const user = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("user")) || {};
    } catch (error) {
      return {};
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (positionDropdownRef.current && !positionDropdownRef.current.contains(event.target)) {
        setShowJobPositionDropdown(false);
      }
      if (locationDropdownRef.current && !locationDropdownRef.current.contains(event.target)) {
        setShowJobLocationDropdown(false);
      }
      if (currencyDropdownRef.current && !currencyDropdownRef.current.contains(event.target)) {
        setShowSalaryCurrencyDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (!user?.id) return;

    const fetchSubscription = async () => {
      try {
        const response = await fetch(
          isAgencyMode
            ? `${BaseUrl}/api/agency/subscription/${user.id}?category=contact`
            : `${BaseUrl}/api/employer/subscription/${user.id}`
        );
        if (!response.ok) return;
        const data = await response.json();
        const planType = (data?.subscription?.plan_type || "").toLowerCase();
        setSenderPlanType(planType || "free");
      } catch (error) {
        console.error(`Failed to fetch ${isAgencyMode ? "agency" : "employer"} subscription:`, error);
      }
    };

    fetchSubscription();
  }, [isAgencyMode, user?.id]);
  
  useEffect(() => {
    if (!user?.id) return;

    const fetchProfile = async () => {
      try {
        // First try to fetch specific role profile
        const roleUrl = isAgencyMode
          ? `${BaseUrl}/api/agency/${user.id}`
          : `${BaseUrl}/api/employer/by-user?user_id=${user.id}`;
        
        const roleRes = await fetch(roleUrl);
        let roleData = null;
        if (roleRes.ok) {
          const rawData = await roleRes.json();
          roleData = isAgencyMode ? rawData : (Array.isArray(rawData) ? rawData[0] : rawData);
        }

        // Always fetch base user info as it's the most reliable for contact info
        // Note: userRoutes is root-mounted as app.use('/', userRoutes)
        const userRes = await fetch(`${BaseUrl}/${user.id}`);
        const userData = userRes.ok ? await userRes.json() : null;
        
        // Merge data: Prefer role-specific data if available, fallback to user data
        const profile = { 
          ...(userData || {}), 
          ...(roleData || {}) 
        };
        
          if (profile.email) setContactEmail((prev) => prev || profile.email);
          
          // Try multiple possible field names for phone and whatsapp including country codes
          const countryCode = profile.phone_number_country_code || 
                              profile.mobile_number_country_code || 
                              profile.official_phone_country_code || 
                              profile.phone_country_code || "";
          
          const rawPhone = profile.phone_number || 
                           profile.mobile_number || 
                           profile.official_phone || 
                           profile.contact_number || 
                           profile.phone || "";
          
          if (rawPhone) {
            const formattedPhone = countryCode ? `${countryCode}${rawPhone}` : rawPhone;
            setContactPhone((prev) => prev || formattedPhone);
          }
          
          const waCountryCode = profile.whatsapp_number_country_code || 
                                profile.whatsapp_country_code || 
                                profile.whatsapp_number_1_country_code || "";
          
          const rawWhatsApp = profile.whatsapp_number || 
                              profile.whatsapp_number_1 || "";
          
          if (rawWhatsApp) {
            const formattedWhatsApp = waCountryCode ? `${waCountryCode}${rawWhatsApp}` : rawWhatsApp;
            setContactWhatsApp((prev) => prev || formattedWhatsApp);
          }
      } catch (error) {
        console.error("Failed to fetch profile details:", error);
      }
    };

    fetchProfile();
  }, [isAgencyMode, user?.id]);

  useEffect(() => {
    const fetchJobPositions = async () => {
      try {
        const response = await fetch(`${BaseUrl}/api/jobposition`);
        if (!response.ok) throw new Error("Failed to fetch job positions");
        const data = await response.json();
        const dbPositions = (Array.isArray(data) ? data : [])
          .map((item) => (item?.position || "").trim())
          .filter(Boolean);

        const mergedPositions = normalizeOptionList([
          ...comprehensiveJobPositions,
          ...sharedDropdownJobPositions,
          ...dbPositions,
        ]);

        setJobPositionOptions(mergedPositions);
      } catch (error) {
        console.error("Failed to load job position options:", error);
        setJobPositionOptions(
          normalizeOptionList([...comprehensiveJobPositions, ...sharedDropdownJobPositions])
        );
      }
    };

    fetchJobPositions();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const requestedJobPosition = params.get("jobPosition");

    if (requestedJobPosition) {
      setJobPosition(requestedJobPosition);
      setJobPositionSearch(requestedJobPosition);
    }
  }, [location.search]);

  const hasWideContactAccess = ["silver", "gold"].includes(senderPlanType);
  const currentPlanLabel = senderPlanType
    ? senderPlanType.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())
    : "Free";

  const filteredJobPositions = useMemo(() => {
    const normalizedSearch = jobPositionSearch.trim().toLowerCase();
    if (!normalizedSearch) return normalizeOptionList(jobPositionOptions);
    return normalizeOptionList(jobPositionOptions).filter((position) =>
      position.toLowerCase().includes(normalizedSearch)
    );
  }, [jobPositionOptions, jobPositionSearch]);

  const filteredCountries = useMemo(() => {
    const normalizedSearch = jobLocationSearch.trim().toLowerCase();
    if (!normalizedSearch) return countries;
    return countries.filter((country) =>
      country.toLowerCase().includes(normalizedSearch)
    );
  }, [jobLocationSearch]);

  const filteredCurrencies = useMemo(() => {
    const normalizedSearch = salaryCurrencySearch.trim().toLowerCase();
    if (!normalizedSearch) return currencyOptions;
    return currencyOptions.filter((curr) =>
      curr.toLowerCase().includes(normalizedSearch)
    );
  }, [salaryCurrencySearch]);

  const handleJobPositionSelect = (position) => {
    setJobPosition(position);
    setJobPositionSearch(position);
    setShowJobPositionDropdown(false);
  };

  const handleJobLocationSelect = (country) => {
    setJobLocation(country);
    setJobLocationSearch(country);
    setShowJobLocationDropdown(false);
  };

  const handleSalaryCurrencySelect = (currency) => {
    setSalaryCurrency(currency);
    setSalaryCurrencySearch("");
    setShowSalaryCurrencyDropdown(false);
  };

  const messageTemplates = [
    (pos, loc, sal) => `Hello, we are hiring for a ${pos || "[Position]"} in ${loc || "[Location]"}. The monthly salary is ${sal}. Please contact us if you are interested.`,
    (pos, loc, sal) => `Looking for a ${pos || "[Position]"} in ${loc || "[Location]"}. Competitive salary of ${sal}. Start immediately. Contact now!`,
    (pos, loc, sal) => `Hiring ${pos || "[Position]"} for ${loc || "[Location]"}. Salary: ${sal}. Contact us directly for more details.`,
    (pos, loc, sal) => `Hi there! We have an opening for a ${pos || "[Position]"} in ${loc || "[Location]"}. Salary offered is ${sal}. We'd love to hear from you!`,
    (pos, loc, sal) => `${pos || "[Position]"} needed in ${loc || "[Location]"}. Salary: ${sal}. Reach out if you are available.`,
    (pos, loc, sal) => `Fresh opportunity for a ${pos || "[Position]"} in ${loc || "[Location]"}. Monthly salary: ${sal}. Please contact us to discuss further.`
  ];

  const handleTemplateCycle = () => {
    const combinedSalary = `${salaryCurrency} ${salaryAmount || "[Amount]"}`;
    const nextIndex = (templateIndex + 1) % messageTemplates.length;
    setTemplateIndex(nextIndex);
    setMessage(messageTemplates[nextIndex](jobPosition, jobLocation, combinedSalary));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!user?.id) {
      Swal.fire(
        "Login Required",
        `Please login as ${isAgencyMode ? "agency" : "employer"} to send alerts.`,
        "warning"
      );
      return;
    }

    if (!jobPosition || !jobLocation || !salaryAmount || !message.trim()) {
      Swal.fire("Missing Fields", "Please fill all required fields.", "warning");
      return;
    }

    if (showContactDetails && !hasWideContactAccess) {
      Swal.fire({
        icon: "warning",
        title: "Upgrade Required",
        text: "Upgrade your plan if you want to show your contact details to the candidates",
        confirmButtonText: "View Plans",
        showCancelButton: true,
      });
      return;
    }

    try {
      setIsSubmitting(true);
      const combinedSalary = `${salaryCurrency} ${salaryAmount}`;
      const response = await fetch(
        `${BaseUrl}/api/${isAgencyMode ? "agency" : "employer"}/send-alert`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            [isAgencyMode ? "agency_id" : "employer_id"]: user.id,
            job_position: jobPosition,
            job_location: jobLocation,
            salary: combinedSalary,
            message: message.trim(),
            contact_email: showContactDetails ? contactEmail.trim() : "",
            contact_phone: showContactDetails ? contactPhone.trim() : "",
            contact_whatsapp: showContactDetails ? contactWhatsApp.trim() : "",
            reach_limit: reachLimit
          })
        }
      );

      const responseText = await response.text();
      let data = {};

      try {
        data = responseText ? JSON.parse(responseText) : {};
      } catch (parseError) {
        data = {
          error: response.status === 404
            ? `The ${isAgencyMode ? "agency" : "employer"} send alert API route was not found.`
            : responseText || "Unexpected server response"
        };
      }

      if (!response.ok) {
        throw new Error(
          data?.error ||
          `${isAgencyMode ? "Agency" : "Employer"} send alert failed with status ${response.status}`
        );
      }

      Swal.fire({
        icon: "success",
        title: "Alert Sent",
        html: `
          <div style="text-align:left">
            <p><strong>Matched Candidates:</strong> ${data.total_matched || 0}</p>
            <p><strong>Website Messages Sent:</strong> ${data.website_messages_sent || 0}</p>
            <p><strong>Emails Sent:</strong> ${data.emails_sent || 0}</p>
          </div>
        `
      });

      setJobPosition("");
      setJobPositionSearch("");
      setJobLocation("");
      setJobLocationSearch("");
      setSalaryAmount("");
      setMessage("");
      setContactEmail("");
      setContactPhone("");
      setContactWhatsApp("");
      setReachLimit(10);
    } catch (error) {
      console.error("Send alert failed:", error);
      Swal.fire("Error", error.message || "Failed to send alert", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="employer-send-alert-page">
      {isAgencyMode ? <AgencyNavbar /> : <EmployerNavbar />}
      <Container className="send-alert-container">
        <Card className="send-alert-card">
          <Card.Header className="send-alert-header text-center">
            <h3>{isAgencyMode ? "Agency Alert Form" : "Instant Alert Form"}</h3>
            <p>
              {isAgencyMode
                ? "Send instant candidate alerts from your agency account by selected job position."
                : "Send instant job alert to candidates by selected job position."}
            </p>
          </Card.Header>

          <Card.Body className="send-alert-body">
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Row className="g-2">
                  <Col xs={5} md={5}>
                    <div className="searchable-dropdown" ref={positionDropdownRef}>
                      <button
                        type="button"
                        className="searchable-dropdown-toggle"
                        onClick={() => setShowJobPositionDropdown((prev) => !prev)}
                      >
                        <span>{jobPosition || "Select Job Position *"}</span>
                        <FaChevronDown className={`searchable-dropdown-chevron ${showJobPositionDropdown ? "open" : ""}`} />
                      </button>

                      {showJobPositionDropdown && (
                        <div className="searchable-dropdown-menu">
                          <div className="searchable-dropdown-search-wrap">
                            <Form.Control
                              type="text"
                              placeholder="Search job position..."
                              value={jobPositionSearch}
                              onChange={(e) => {
                                setJobPositionSearch(e.target.value);
                                setJobPosition("");
                              }}
                              onFocus={() => setShowJobPositionDropdown(true)}
                              autoComplete="off"
                            />
                          </div>

                          <div className="searchable-dropdown-options-list">
                            {filteredJobPositions.length ? (
                              filteredJobPositions.map((position) => (
                                <button
                                  type="button"
                                  key={position}
                                  className={`searchable-dropdown-option ${jobPosition === position ? "active" : ""}`}
                                  onClick={() => handleJobPositionSelect(position)}
                                >
                                  {position}
                                </button>
                              ))
                            ) : (
                              <div className="searchable-dropdown-empty">No matching job position found</div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </Col>

                  <Col xs={7} md={7}>
                    <div className="searchable-dropdown" ref={locationDropdownRef}>
                      <button
                        type="button"
                        className="searchable-dropdown-toggle"
                        onClick={() => setShowJobLocationDropdown((prev) => !prev)}
                      >
                        <span>{jobLocation || "Job Location *"}</span>
                        <FaChevronDown className={`searchable-dropdown-chevron ${showJobLocationDropdown ? "open" : ""}`} />
                      </button>

                      {showJobLocationDropdown && (
                        <div className="searchable-dropdown-menu">
                          <div className="searchable-dropdown-search-wrap">
                            <Form.Control
                              type="text"
                              placeholder="Search country..."
                              value={jobLocationSearch}
                              onChange={(e) => {
                                setJobLocationSearch(e.target.value);
                                setJobLocation("");
                              }}
                              onFocus={() => setShowJobLocationDropdown(true)}
                              autoComplete="off"
                            />
                          </div>

                          <div className="searchable-dropdown-options-list">
                            {filteredCountries.length ? (
                              filteredCountries.map((country) => (
                                <button
                                  type="button"
                                  key={country}
                                  className={`searchable-dropdown-option ${jobLocation === country ? "active" : ""}`}
                                  onClick={() => handleJobLocationSelect(country)}
                                >
                                  {country}
                                </button>
                              ))
                            ) : (
                              <div className="searchable-dropdown-empty">No matching country found</div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </Form.Group>

              <Form.Group className="mb-3">
                <Row className="g-2">
                  <Col xs={5} md={5}>
                    <div className="searchable-dropdown" ref={currencyDropdownRef}>
                      <button
                        type="button"
                        className="searchable-dropdown-toggle salary-currency-select"
                        onClick={() => setShowSalaryCurrencyDropdown((prev) => !prev)}
                      >
                        <span>{salaryCurrency}</span>
                        <FaChevronDown className={`searchable-dropdown-chevron ${showSalaryCurrencyDropdown ? "open" : ""}`} />
                      </button>

                      {showSalaryCurrencyDropdown && (
                        <div className="searchable-dropdown-menu">
                          <div className="searchable-dropdown-search-wrap">
                            <Form.Control
                              type="text"
                              placeholder="Search currency..."
                              value={salaryCurrencySearch}
                              onChange={(e) => setSalaryCurrencySearch(e.target.value)}
                              onFocus={() => setShowSalaryCurrencyDropdown(true)}
                              autoComplete="off"
                            />
                          </div>

                          <div className="searchable-dropdown-options-list">
                            {filteredCurrencies.length ? (
                              filteredCurrencies.map((curr) => (
                                <button
                                  type="button"
                                  key={curr}
                                  className={`searchable-dropdown-option ${salaryCurrency === curr ? "active" : ""}`}
                                  onClick={() => handleSalaryCurrencySelect(curr)}
                                >
                                  {curr}
                                </button>
                              ))
                            ) : (
                              <div className="searchable-dropdown-empty">No matching currency found</div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col xs={7} md={7}>
                    <Form.Control
                      type="text"
                      placeholder="Salary amount (e.g. 3000 - 4500) *"
                      value={salaryAmount}
                      onChange={(e) => setSalaryAmount(e.target.value)}
                      required
                    />
                  </Col>
                </Row>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Message (Describe job position) *"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  className="send-alert-textarea"
                  required
                />
                <div className="d-flex justify-content-end mt-1">
                  <Button 
                    variant="link" 
                    size="sm" 
                    className="change-desc-btn-link"
                    onClick={handleTemplateCycle}
                  >
                    Auto Generate Description
                  </Button>
                </div>
              </Form.Group>

              <Form.Group className="mb-3">
                <Row>
                  <Col md={6} className="mb-2 mb-md-0">
                    <InputGroup>
                      <InputGroup.Text className="contact-input-icon">
                        <FaPhone />
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        placeholder={isAgencyMode ? "Agency phone number" : "Employer phone number"}
                        value={contactPhone}
                        onChange={(e) => setContactPhone(e.target.value)}
                      />
                    </InputGroup>
                  </Col>
                  <Col md={6}>
                    <InputGroup>
                      <InputGroup.Text className="contact-input-icon contact-input-icon--whatsapp">
                        <FaWhatsapp />
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        placeholder={isAgencyMode ? "Agency WhatsApp number" : "Employer WhatsApp number"}
                        value={contactWhatsApp}
                        onChange={(e) => setContactWhatsApp(e.target.value)}
                      />
                    </InputGroup>
                  </Col>
                </Row>
              </Form.Group>

              <Form.Group className="mb-3">
                <InputGroup>
                  <InputGroup.Text className="contact-input-icon">
                    <FaEnvelope />
                  </InputGroup.Text>
                  <Form.Control
                    type="email"
                    placeholder={isAgencyMode ? "Agency email" : "Employer email"}
                    value={contactEmail}
                    onChange={(e) => setContactEmail(e.target.value)}
                  />
                </InputGroup>
              </Form.Group>


              <Form.Group className="mb-4">
                <div className="contact-visibility-group">
                  <div className="row g-2 contact-visibility-row">
                    <div className="col-md-6">
                      <div 
                        className={`contact-visibility-option ${showContactDetails ? "contact-visibility-option--active" : ""}`}
                        onClick={() => setShowContactDetails(true)}
                      >
                        <div className="cv-checkbox-wrap">
                          {showContactDetails && <FaCheck className="cv-checkmark" />}
                        </div>
                        <div className="cv-content">
                          <div className="cv-title-wrap">
                            <span className="cv-title">Show my contact details to all jobseekers</span>
                            <span className="recommended-badge">Recommended</span>
                          </div>
                          <p className="cv-subtext cv-subtext-success">
                            <FaCheck /> Anyone can call or contact you directly
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div 
                        className={`contact-visibility-option ${!showContactDetails ? "contact-visibility-option--active" : ""}`}
                        onClick={() => setShowContactDetails(false)}
                      >
                        <div className="cv-checkbox-wrap">
                          {!showContactDetails && <FaCheck className="cv-checkmark" />}
                        </div>
                        <div className="cv-content">
                          <div className="cv-title-wrap">
                            <span className="cv-title">Do not show my contact details</span>
                          </div>
                          <p className="cv-subtext">Only subscribed jobseekers can contact you</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Text
                  className={
                    hasWideContactAccess
                      ? "send-alert-contact-note"
                      : "send-alert-contact-note send-alert-contact-note--warning"
                  }
                >
                  {hasWideContactAccess
                    ? `Because your plan is Silver or Gold, your ${isAgencyMode ? "agency contact" : "contact"} details will be visible to all matched candidates.`
                    : "You can still send alerts with your contact details. On your current plan, they will be visible only to candidates with an active Silver or Gold subscription. Upgrade to Silver or Gold to make your contact details visible to all candidates."}
                </Form.Text>
                <div className="send-alert-plan-indicator text-center">Your current plan: {currentPlanLabel}</div>
              </Form.Group>


              <div className="send-alert-btn-wrap">
                <Button type="submit" className="send-alert-btn" disabled={isSubmitting}>
                  {isSubmitting ? "Sending..." : "Send Alert"}
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};


export default SendAlert;
